import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Arrow from 'assets/images/Arrow.png';

const useStyles = makeStyles((theme) => ({
  HowPodWorkBox: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '297px',
    justifyContent: 'center',
    border: '1px dashed #fff',
    borderRadius: '30px',
    position: 'relative',
    margin: '0px auto',
    minHeight: '94px',
    backgroundColor: '#04B078',
    cursor: 'pointer',

    [theme.breakpoints.down('md')]: {
      width: '277px',
    },

    '&::before': {
      content: "''",
      position: 'absolute',
      left: '39%',
      bottom: '-33px',
      width: '21%',
      borderBottom: '1px dashed #fff',
      transform: 'rotate(90deg)',
    },

    '&::after': {
      content: "''",
      position: 'absolute',
      backgroundImage: `url(${Arrow.src})`,
      width: '16px',
      height: '18px',
      bottom: '-39px',
      left: '46.5%',
      transform: 'rotate(0deg)',
    },
  },
  HowPodWorkBoxBefore: {
    '&::before': {
      left: 'initial',
      right: '-48px',
      bottom: '50%',
      width: '16%',
      transform: 'rotate(0deg)',

      [theme.breakpoints.down('sm')]: {
        content: "''",
        position: 'absolute',
        left: '39%',
        bottom: '-33px',
        width: '21%',
        borderBottom: '1px dashed #fff',
        transform: 'rotate(90deg)',
      },
    },

    '&::after': {
      bottom: '41%',
      left: 'initial',
      right: '-31px',
      transform: 'rotate(-90deg)',
      [theme.breakpoints.down('sm')]: {
        content: "''",
        position: 'absolute',
        backgroundImage: `url(${Arrow.src})`,
        width: '16px',
        height: '18px',
        bottom: '-39px',
        left: '47%',
        transform: 'rotate(0deg)',
      },
    },
  },
  HowPodWorkBoxup: {
    '&::before': {
      left: '39%',
      bottom: 'initial',
      top: '-30px',

      [theme.breakpoints.down('sm')]: {
        top: 'initial',
        left: '39%',
        bottom: '-33px',
        width: '21%',
        borderBottom: '1px dashed #fff',
        transform: 'rotate(90deg)',
      },
    },
    '&::after': {
      transform: 'rotate(180deg)',
      bottom: 'initial',
      top: '-41px',
      [theme.breakpoints.down('sm')]: {
        content: "''",
        top: 'initial',
        position: 'absolute',
        backgroundImage: `url(${Arrow.src})`,
        width: '16px',
        height: '18px',
        bottom: '-39px',
        left: '47%',
        transform: 'rotate(0deg)',
      },
    },
  },
  HowPodWorkBoxNoLine: {
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  },

  HowPodWorkBoxMenu: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',

    '& span': {
      background: '#fff',
      borderRadius: '50%',
      padding: '8px 0px',
      lineHeight: 1,
      display: 'block',
      margin: '0px 21px',
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#008B5E',
      width: '32px',
      height: '32px',
    },
  },
  HowPodWorkContent: {
    display: 'inline-block',
    wordBreak: 'break-all',
    width: 'calc(100% - 108px)',
    padding: '15px 0px',

    '& p': {
      textAlign: 'start',
      padding: '0px',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '26px',
      margin: '0px',
      color: '#fff',

      [theme.breakpoints.down('md')]: {
        fontSize: '18px',
      },
    },
  },

  image: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '-26px',
    background: '#04B078',
    right: '6px',
    width: '53px',
    height: '47px',
  },
}));

export default function HowPodWorkMenuBox({
  number,
  content1,
  content2,
  content3,
  content4,
  img,
  className,
}) {
  const classes = useStyles();
  return (
    <div className={`${classes.HowPodWorkBox} ${classes[className]}`}>
      <div className={classes.HowPodWorkBoxMenu}>
        <Typography component="span">{number}</Typography>
        <div className={classes.HowPodWorkContent}>
          <Typography variant="body1">{content1}</Typography>
          <Typography variant="body1">{content2}</Typography>
          <Typography variant="body1">{content3}</Typography>
          <Typography variant="body1">{content4}</Typography>
        </div>
      </div>
      <div className={classes.image}>
        <img src={img.src} alt="" />
      </div>
    </div>
  );
}
